<template>
  <div class="login-box">
    <div class="loginFont">登录</div>
    <div class="desFont">共创健康生活 共享职业健康</div>
    <!-- 本机号码一键登录 -->
    <div v-if="loginMode === 0">
      <div class="phoneNumber">188****5669</div>
      <div>
        <button form-type="submit" class="oneClick">
          <span style="color: #f8f8f8">本机号码一键登录</span>
        </button>
      </div>
      <div class="under">
        <div class="phoneLogin" @click="loginMode = 1">验证码登录</div>
        <div>&nbsp;|&nbsp;</div>

        <div class="verifyLogin">
          <div class="numberLogin" @click="loginMode = 2">账号密码登录</div>
        </div>
      </div>
      <div class="outer2"></div>

      <div class="foot2">
        <div class="read">已阅读并同意</div>
        <div class="agreement">《职业健康数字化平台服务协议》</div>
        <div class="and">以及</div>
        <div class="secrecy">《隐私政策》</div>
      </div>
    </div>
<!-- 账号密码登录 -->
    <div v-if="loginMode === 2">
      <el-form
        ref="form"
        :model="form"
        :rules="submitRules"
        class="form"
      >
        <el-form-item prop="user" class="inputNub">
          <el-input
            v-model="form.user"
            placeholder="请输入账号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" class="inputpwd">
          <el-input
            type="password "
            v-model="form.password"
            placeholder="请输入密码"
            show-password
            clearable
          ></el-input>
        </el-form-item>
        <button form-type="submit" class="loginBtn" @click="onSubmit()">
          <span style="color: #f8f8f8">登录</span>
        </button>
      </el-form>
      <div class="under">
        <div class="phoneLogin" @click="loginMode = 0">本机号码一键登录</div>
        <div>&nbsp;|&nbsp;</div>

        <div class="verifyLogin" @click="loginMode = 1">
          <div class="numberLogin">验证码登录</div>
        </div>
      </div>
      <div class="outer1"></div>

      <div class="foot">
        <div class="read">已阅读并同意</div>
        <div class="agreement">《职业健康数字化平台服务协议》</div>
        <div class="and">以及</div>
        <div class="secrecy">《隐私政策》</div>
      </div>
    </div>
<!-- 验证码登录 -->
    <div v-if="loginMode === 1">
      <el-form
        ref="form"
        :model="form"
        :rules="submitRules"
      >
        <el-form-item prop="phoneNum" class="inputNub">
          <el-input
            v-model="form.phoneNumber"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="code"  class="inputpwd">
          <el-input
            v-model="form.code"
            type="password "
            placeholder="请输入验证码"
            class="input"
           
          >
                     <el-button class="ltbut" slot="suffix" type="text"  :disabled="ioncode" @click="getVCode">{{vcodeBtnName}}</el-button>

          </el-input>
          <!-- <button @click="getCode(regForm)" class="code-btn" :disabled="!show">
        <span v-show="show">发送验证码</span>
        <span v-show="!show" class="count">{ undefined{count}} s</span>
     </button> -->
        </el-form-item>
        <button form-type="submit" class="loginBtn" @click="phoneLogin()">
          <span style="color: #f8f8f8">登录</span>
        </button>
        <!-- <el-button  @click="onSubmit('form')" style="backgroud-color=#0063e0 " >立即登录</el-button> -->
      </el-form>
      <div class="under">
        <div class="phoneLogin" @click="loginMode = 0">本机号码一键登录</div>
        <div>&nbsp;|&nbsp;</div>

        <div class="verifyLogin" @click="loginMode = 2">
          <div class="numberLogin">账号密码登录</div>
        </div>
      </div>
      <div class="outer1"></div>

      <div class="foot">
        <div class="read">已阅读并同意</div>
        <div class="agreement">《职业健康数字化平台服务协议》</div>
        <div class="and">以及</div>
        <div class="secrecy">《隐私政策》</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    // const validatePassword = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error("密码不能少于6位"));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      Obtain: '', // 获取验证码倒计时
             timer: null,
             ioncode: false, // 禁用倒计时按妞
             vcodeBtnName:"获取验证码",
      loginMode: 0,
      countNum : 120,
			countDownTimer : null, // 定时器
      radio: "1",
      user: "",
      password: "",
      phoneNumber: "",
      code:"",
      form: {
        user: "",
        password: "",
        phoneNumber: "",
        code: "",
      },
      // ruleForm: {
      //    user: '',
      //    phoneNub:'',
      //     password:'',
      //      code:'',

      //   },
      submitRules: {
        user: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 5, message: "长度不小于六个字符", trigger: "blur" },
        ],
        phoneNum: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, message: "密码不可以少于六个字符", trigger: "blur" },
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }],
      },
    };
  },
  methods: {
      getVCode(){
			// var myreg=/^[1][0-9]{10}$/;
			// if (!myreg.test(this.phone)){
			// 	// uni.showToast({ title: '请正确填写手机号码', icon : "none"});
			// 	return false;
			// }
			// vcodeBtnName 可以阻止按钮被多次点击 多次发送 return 会终止函数继续运行
      console.log("进来getcode")
			if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送'){return ;}
			this.vcodeBtnName =  "发送中...";
			// 与后端 api 交互，发送验证码 
			this.sendCode();
		},
		sendCode() {
			axios.get('https://oapi.zyws.net/app/sendVerificationCode?phoneNum='+this.form.phoneNumber+'&countryCode=86&messageType=1').then((res) => {
				if (res.status == 200) {
					// uni.showToast({ title: '验证码已发送', icon : "success"});
					// 倒计时
					this.countNum = 120;
					this.countDownTimer = setInterval(function(){this.countDown();}.bind(this), 1000);
				} else {
					// uni.showToast({
					// 	title: "验证码发送失败",
					// 	icon: "none"
					// })
          alert("发送失败")
				}
			})
		},
  	countDown(){
			if (this.countNum < 1){
			  clearInterval(this.countDownTimer);
			  this.vcodeBtnName = "重新发送";
			  return ;
			}
			this.countNum--;
			this.vcodeBtnName =  this.countNum + '秒重发';
		},
    //验证码登录
    phoneLogin() {
			axios.post("https://oapi.zyws.net/app/user/smDoLogin",{
				phoneNum: this.form.phoneNumber,
				countryCode: "86",
				messageCode: this.form.code
			}).then((res) => {
				console.log('phoneLogin: ', res);
				if (res.status == 200) {
					// this.$store.commit('login', res.data.user);
					console.log('手机登录返回的信息：', res.data);
					// res.data.userToken && uni.setStorageSync('userToken', res.data.userToken);
					// if(!res.data.user.companyStatus && res.data.user.phoneNum){
					// 	this.getCompanysByPhoneNum(res.data.user.phoneNum);
					// }else{
					// 	uni.showToast({
					// 		title: res.message,
					// 		icon: "success",
					// 	});
					// 	this.goHome();
					// }
				} else {
          alert("登录失败")
					// uni.showToast({
					// 	title: res.message,
					// 	icon: "none",
					// 	duration: 2000,
					// });
				}
			})
		},





    onSubmit(formName) {
      //验证
      if (1) {
        axios
          .post("https://oapi.zyws.net/app/user/doLogin", {
            userName: this.form.user,
            password: this.form.password,
          })
          .then((res) => {
            if (res.data.status == 200) {
              alert("登录成功");
              console.log(res);
              localStorage.setItem("userToken", res.userToken);
              this.$router.push("indexSub");
            }else{
              alert("登录失败")
            }
          });
      } else {
        console.log("error submit!!");
        alert("登录失败")
        return false;
      }
    },
     get_verification() {
      const verify = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
      
        if (verify.test(this.form.phoneNum)) {
          console.log('请求接口获取验证码')
          const TIME_COUNT = 60
          if (!this.timer) {
            this.Obtain = TIME_COUNT
            this.ioncode = true
            this.timer = setInterval(() => {
              if (this.Obtain > 0 && this.Obtain <= TIME_COUNT) {
                this.Obtain--
              } else {
                this.ioncode = false
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        } 
    }
      

  },
};
</script>
<style scoped>
.outer1 {
  margin-top: 15.3rem;
  margin-left: 1.5rem;
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  border: 0.1rem solid rgba(171, 174, 179, 0.5);
  border-radius: 50%;
}
.agreement {
  float: left;
  color: #1678ff;
}
.secrecy {
  float: left;
  color: #1678ff;
}
.read {
  float: left;
}
.and {
  float: left;
}
.verifyLogin {
  font-size: 0.9rem;
  font-weight: 300;
  text-align: center;
}
.phoneLogin {
  font-size: 0.9rem;
  font-weight: 400;
}
.loginBtn {
  background: #0063e0;
  border-radius: 0.2rem;
  margin-top: 0.5rem;
  height: 3.2rem;
  font-size: 1rem;
  width: 21rem;
  margin-left: 1.6rem;
  border: 0rem;
}
.verifyLogin {
  font-size: 0.9rem;
  font-weight: 300;
  text-align: center;
}
.codeBtn {
  float: left;
  width: 8rem;
  height: 1.8rem;
  margin-top: 0.6rem;
  color: rgba(42, 145, 252, 1);
  font-size: 16px;
  border-bottom: 1rem solid #e9e9e9;
  background-color: #f8f8f8;
  border-style: solid;
  border-top-width: 0rem;
  border-left-width: 0rem;
  border-right-width: 0rem;
  border-bottom-width: 1px;
}
.foot {
  margin-top: 15.1rem;
  margin-left: 2.5rem;
  width: 18.79rem;
  height: 2rem;
  font-size: 0.5rem;
}

.outer {
  margin-top: 22.75rem;
  margin-left: 1.5rem;
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  border: 0.1rem solid rgba(171, 174, 179, 0.5);
  border-radius: 50%;
}
.loginFont {
  margin: 7rem 0 0 0.27rem;
  font-size: 2.1rem;
  font-weight: 550;
  color: #303133;
  line-height: 64px;
  margin-left: 1.6rem;
}
.desFont {
  margin-left: 1.6rem;
  margin-top: -0.6rem;
  display: block;
  font-size: 1.04rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 330;
  color: #303133;
  line-height: 44px;
}

.agreement {
  float: left;
  color: #1678ff;
}
.secrecy {
  float: left;
  color: #1678ff;
}
.read {
  float: left;
}
.and {
  float: left;
}
.under {
  display: flex;
  margin-top: 1.4rem;
  justify-content: center;
}
.numberLogin {
  font-size: 0.9rem;
  font-weight: 400;
}
.phoneNumber {
  font-size: 1.9rem;
  font-family: DINCondensed-Bold, DINCondensed;
  font-weight: bold;
  color: #303133;
  text-align: center;
  margin-top: 6.7rem;
}
.oneClick {
  background: #0063e0;
  border-radius: 0.2rem;
  margin-top: 1rem;
  height: 3.2rem;
  font-size: 1rem;
  width: 21rem;
  margin-left: 1.6rem;
  border: 0rem;
}
.login {
  background-color: #fff;
}
/* .el-input__inner {
  height: 1.8rem !important;
  font-size: 1rem !important;
  border: 0;
  background-color: #f6f6f6;
  border-bottom: 0.1rem solid #e9e9e9;
  width: 21rem;
  padding-right: 6rem;
} */
.radio {
  margin-top: 16.4rem;
}
.inputNub .el-form-item {
  margin-top: 6.5rem;
  width: 21rem;
    margin-left: 1.6rem;

}
.inputpwd{
    width: 21rem;
    margin-left: 1.6rem;

}
.outer2 {
  margin-top: 20.55rem;
  margin-left: 1.5rem;
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  border: 0.1rem solid rgba(171, 174, 179, 0.5);
  border-radius: 50%;
}
.foot2 {
  margin-top: 20.5rem;
  margin-left: 2.5rem;
  width: 18.79rem;
  height: 2rem;
  font-size: 0.5rem;
}
.ltbut{
margin-right:2.2rem;
  font-size: 1rem !important;

}
</style>



// WEBPACK FOOTER //
// src/components/subPage/logindemo.vue